"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const styled_components_1 = require("styled-components");
const tag_hoc_1 = require("tag-hoc");
const component_icon_1 = require("@patternplate/component-icon");
const component_link_1 = require("@patternplate/component-link");
const InnerButton = props => {
    const { className, title, onClick, external, href, type, symbol, children } = props;
    const OuterElement = type === ButtonTypes.link
        ? tag_hoc_1.default(["external", "type"])(component_link_1.Link)
        : tag_hoc_1.default(["external"])("button");
    return (React.createElement(OuterElement, { className: className, title: title, onClick: onClick, external: external, href: href, type: type },
        children && React.createElement(StyledLabel, null, children),
        symbol && React.createElement(StyledIcon, { symbol: symbol })));
};
const StyledLabel = styled_components_1.default.span `
  font-family: ${props => props.theme.fonts.default};
`;
const StyledIcon = styled_components_1.default(component_icon_1.Icon) `
  &:not(:first-child) {
    margin-left: 5px;
  }
`;
var ButtonTypes;
(function (ButtonTypes) {
    ButtonTypes[ButtonTypes["button"] = 0] = "button";
    ButtonTypes[ButtonTypes["link"] = 1] = "link";
})(ButtonTypes = exports.ButtonTypes || (exports.ButtonTypes = {}));
exports.Button = styled_components_1.default(InnerButton) `
  appearance: none;
  display: inline-flex;
  height: 40px;
  align-items: center;
  justify-content: center;
  padding: 5px;
  border: none;
  outline: 0;
  background: ${props => props.theme.colors.background};
  color: ${props => props.theme.colors.color};
  font: inherit;
  box-sizing: border-box;
  vertical-align: top;
  ${props => props.frameless && styled_components_1.css `
    padding: 4px;
    border: 1px solid currentColor;
  `};
  background: ${props => props.transparent && 'transparent'}
`;
exports.Button.defaultProps = {
    type: ButtonTypes.button
};
//# sourceMappingURL=button.js.map